import { Checkbox, Form, type FormInstance, Input, Space } from 'antd';
import { type FC, useEffect } from 'react';
import { validates } from '@/utils';
import AddressCascaderFormItem from '../AddressCascaderFormItem';
import styles from './EditAddressForm.less';

const { Item } = Form;

type EditAddressFormProps = {
  form?: FormInstance;
  currentAddress?: any;
  handleSubmit?: (...args: any) => void;
  onCancel?: () => void;
};

const EditAddressForm: FC<EditAddressFormProps> = ({
  form,
  currentAddress,
  handleSubmit,
  onCancel,
}) => {
  useEffect(() => {
    if (currentAddress) {
      form?.setFieldsValue(currentAddress);
    }
  }, [currentAddress]);

  return (
    <Form
      form={form}
      size="large"
      preserve={false}
      className={styles.editAddressWrap}
    >
      <div className="flex flex-row justify-between">
        <div>
          <Item
            name="areas"
            label="所在地区"
            rules={[{ type: 'array', required: true, message: '请选择地区' }]}
          >
            <AddressCascaderFormItem />
          </Item>
          <Item
            label="详细地址"
            name="address"
            rules={[
              {
                required: true,
                whitespace: true,
                message: `请输入详细地址`,
              },
              {
                max: 50,
                whitespace: true,
                message: '地址不超过50字',
              },
            ]}
          >
            <Input.TextArea
              placeholder="详细地址，街道、门牌号等"
              className={styles.addressDetailInput}
            />
          </Item>
          <Space>
            <Item
              required
              label="收货人"
              name="contactName"
              className="w-[297px]"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: '请输入收货人',
                },
                {
                  max: 20,
                  whitespace: true,
                  message: '收货人不超过20字',
                },
              ]}
            >
              <Input placeholder="请输入姓名" />
            </Item>
            <Item
              required
              label="手机号码"
              name="contactTel"
              className="w-[297px]"
              rules={[
                {
                  required: true,
                  message: `请输入正确的手机号码`,
                },
                () => ({
                  validator: validates('phone'),
                }),
              ]}
            >
              <Input placeholder="请输入手机号码" />
            </Item>
          </Space>
        </div>
        <div className="h-[168px] border-l-[1px] border-solid border-[#EEEEEE] flex justify-center flex-col px-[40px]">
          <Item label="" name="isDefault" colon={false} valuePropName="checked">
            <Checkbox className="text-[#333333] text-[14px] font-normal">
              设为默认收货地址
            </Checkbox>
          </Item>
          <div className="flex flex-row">
            <div
              onClick={handleSubmit}
              className="bg-[#333333] text-[#FFFFFF] font-medium text-[16px] rounded-[4px] cursor-pointer w-[114px] h-[42px] flex justify-center items-center hover:bg-[#EAE8E4] hover:text-[#333333]"
            >
              保存地址
            </div>
            <div
              onClick={onCancel}
              className="bg-[#eee] border-[#333333] border-[1px] border-solid rounded-[4px] cursor-pointer w-[114px] h-[42px] flex justify-center items-center ml-[16px] hover:bg-[#fff]"
            >
              <span className="text-[#333333] font-medium text-[16px]">
                取消
              </span>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default EditAddressForm;
